import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink, ShieldCheck } from "lucide-react";
import { AFFILIATE_URLS, onAffiliateClick } from "../config/affiliate";

const PartnersSection = () => {
  return (
    <section className="py-16 bg-white" data-testid="home-partners-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-block px-4 py-2 bg-[#fdf2f4] border border-[#e8c5b8] rounded-full mb-4">
            <span className="text-sm text-[#b89a6d] font-medium">Educational Referral Partners</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#3a2a26] mb-3">
            We work closely with AlphaSync Rx and MyDose.ai
          </h2>
          <p className="text-sm md:text-base text-[#5a4a40] max-w-2xl mx-auto leading-relaxed">
            For readers who want clinician-supervised pathways, we point to two partner platforms used by
            licensed clinicians and pharmacies. PeptidesForMedSpas is not a pharmacy, med spa, or medical
            provider — these partnerships are educational, not commercial.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <a
            href={AFFILIATE_URLS.alphasync}
            target="_blank"
            rel="noopener noreferrer nofollow"
            data-testid="home-partner-alphasync"
            onClick={onAffiliateClick({ partner: "alphasync", product: "partner-card", url: AFFILIATE_URLS.alphasync })}
            className="group bg-[#fffaf5] border border-[#f0d8d4] hover:border-[#d4a5ad] rounded-2xl p-6 transition-all"
          >
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-lg font-bold text-[#3a2a26] group-hover:text-[#b89a6d] transition-colors">
                AlphaSync Rx
              </h3>
              <ExternalLink className="w-5 h-5 text-[#b89a6d] opacity-60 group-hover:opacity-100" />
            </div>
            <p className="text-xs text-[#a09186] mb-3 font-mono">www.alphasyncrx.com</p>
            <p className="text-sm text-[#5a4a40] leading-relaxed">
              Modern dispensing infrastructure connecting licensed physicians with licensed pharmacy
              partners. Coordinates dispensing of peptides, hormone therapies, fertility medications,
              pharmacy-grade nutraceuticals, and longevity therapies — physician-centered.
            </p>
          </a>

          <a
            href={AFFILIATE_URLS.mydose}
            target="_blank"
            rel="noopener noreferrer nofollow"
            data-testid="home-partner-mydose"
            onClick={onAffiliateClick({ partner: "mydose", product: "partner-card", url: AFFILIATE_URLS.mydose })}
            className="group bg-[#fffaf5] border border-[#f0d8d4] hover:border-[#d4a5ad] rounded-2xl p-6 transition-all"
          >
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-lg font-bold text-[#3a2a26] group-hover:text-[#b89a6d] transition-colors">
                MyDose.ai
              </h3>
              <ExternalLink className="w-5 h-5 text-[#b89a6d] opacity-60 group-hover:opacity-100" />
            </div>
            <p className="text-xs text-[#a09186] mb-3 font-mono">www.mydose.ai</p>
            <p className="text-sm text-[#5a4a40] leading-relaxed">
              Peptide-therapy management platform for licensed med spas, longevity clinics, gyms, and
              telehealth providers. Handles patient intake, clinician oversight, and pharmacy fulfillment
              workflows — operated for licensed clinicians, not direct-to-consumer.
            </p>
          </a>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center items-center text-sm">
          <Link
            to="/partners"
            data-testid="home-partners-learn-more"
            className="inline-flex items-center gap-2 text-[#b89a6d] hover:text-[#a08560] font-semibold"
          >
            Learn more about our partners →
          </Link>
          <span className="hidden sm:inline text-[#e8c5b8]">·</span>
          <Link
            to="/compliance"
            data-testid="home-partners-compliance"
            className="inline-flex items-center gap-2 text-[#b89a6d] hover:text-[#a08560] font-semibold"
          >
            <ShieldCheck className="w-4 h-4" /> Our compliance posture
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
